export const environment = {
  api_url: "https://api.teste.ultracondominio.com.br/api/"
};
